import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

// Lazy load documents list for code splitting
const DocumentsListPage = lazyWithRetry(() => import('./components/DocumentsListPage'));

/**
 * Documents Page
 * Main entry point for the documents feature
 */
export const DocumentsPage: React.FC = () => {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <DocumentsListPage />
    </Suspense>
  );
};

export default DocumentsPage;

